import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
// Components
import Spinner from "../Components/Spinner";
import ToastError from "../Components/ToastError";
import { clientService } from "../../Services/client.service";

const ClientDetails = () => {
  const { t } = useTranslation();
  
  let { id } = useParams();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [activeTab, setActiveTab] = useState('identification');
  const [client, setClient] = useState({});
  const [hasSecondAddress, setSecondAddress] = useState(true)
  const [labels, setLabels] = useState({
    fantasyName: t("CLIENT_DETAILS.FANTASY_NAME"),
    socialName: t("CLIENT_DETAILS.SOCIAL_NAME")
  });
  
	// eslint-disable-next-line
  const [optanteSimples, setOptanteSimples] = useState(null);
	// eslint-disable-next-line
  const [isPublic, setIsPublic] = useState(null);

  

  // const userData = storage.get(storageKeys.access_and_token);
  
  //carregando dados de V3 global
  useEffect(() => {
    dispatch({ type: "title", value: t("CLIENT_DETAILS.VIEW_CLIENT")});
    const fetchClientAsync = async () => {
      
      let clientId = id ? id : client?.clientId;

      if (clientId) {
        setIsLoading(true)
        const response = await clientService.fetchClient(clientId);
        setClient(response);
        setIsLoading(false)
      }
    };
    setSecondAddress(!client?.mailingZipCode)
    fetchClientAsync();
  // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (client?.taxId?.length === 11) {
      setLabels({
        fantasyName: t("CLIENT_DETAILS.SHORT_NAME"),
        socialName: t("CLIENT_DETAILS.FULL_NAME")
      });
    } else {
      setLabels({
        fantasyName: t("CLIENT_DETAILS.FANTASY_NAME"),
        socialName: t("CLIENT_DETAILS.SOCIAL_NAME")
      });
    }
  }, [client?.taxId, t]);
  

  if (isLoading) return  <Spinner /> 
  return (
    <>
      <div className='container-xxl flex-grow-1 container-p-y'>
        <h4 className='fw-bold py-3 mb-4'>
          <span className='text-muted fw-light'>{t("CLIENT_DETAILS.PAGE_TITLE")}</span>
        </h4>


        <ToastError show={showToast} closeToast={() => setShowToast(false)} />

        <div className="row">
          <div className="mb-3 col-4">
            <label for="html5-text-input" className="col-md-4 col-form-label">{labels.socialName}</label>
            <div className="col-md-10">
              <input
                type='text'
                className='form-control'
                placeholder={t("CLIENT_DETAILS.SOCIAL_NAME")}
                name='atualize'
                value={client?.tradeName}
                disabled
              />
            </div>
          </div>
          <div className="mb-3 col-4">
            <label for="html5-text-input" className="col-md-4 col-form-label">{labels.fantasyName}</label>
            <div className="col-md-10">
              <input
                type='text'
                className='form-control'
                placeholder={t("CLIENT_DETAILS.SOCIAL_NAME")}
                value={client?.socialName}
                disabled
              />
            </div>
          </div>

        </div>

        <div className='row'>

          <div className="nav-align-top mb-4">
            <ul className="nav nav-tabs" id="myTab" role="tablist">
              <li className="nav-item">
                <button type="button" className={activeTab == "identification" ? "nav-link active" : "nav-link"}
                  onClick={() => setActiveTab('identification')} role="tab"
                  data-bs-toggle="tab" data-bs-target="#navs-top-identification"
                  aria-controls="navs-top-identification" aria-selected="true">{t("CLIENT_DETAILS.IDENTIFICATION")}</button>
              </li>
              <li className="nav-item">
                <button type="button" className={activeTab == "address" ? "nav-link active" : "nav-link"}
                  onClick={() => setActiveTab('address')} role="tab" data-bs-toggle="tab"
                  data-bs-target="#navs-top-address" aria-controls="navs-top-address" aria-selected="false">
                    {t("CLIENT_DETAILS.ADDRESS")} {hasSecondAddress ? '1' : ''}
                  </button>
              </li>
              {hasSecondAddress && (
                <li className="nav-item">
                  <button type="button" className={activeTab == "address2" ? "nav-link active" : "nav-link"}
                  onClick={() => setActiveTab('address2')} role="tab" data-bs-toggle="tab"
                  data-bs-target="#navs-top-address2" aria-controls="navs-top-address2" aria-selected="false">
                    {t("CLIENT_DETAILS.ADDRESS_2")}
                  </button>
                </li>
              )}
              <li className="nav-item">
                <button type="button" className={activeTab == "companyRegistration" ? "nav-link active" : "nav-link"}
                  onClick={() => setActiveTab('companyRegistration')} role="tab"
                  data-bs-toggle="tab" data-bs-target="#navs-top-companyRegistration"
                  aria-controls="navs-top-companyRegistration" aria-selected="true">{t("CLIENT_DETAILS.COMPANY_REGISTRATION")}</button>
              </li>
            </ul>
            <div className="tab-content">

              <div className={activeTab == "identification" ? "tab-pane fade active show" : "tab-pane fade"} id="navs-top-identification" role="tabpanel">

                <div className="row">
                  <div className="mb-3 col-4">
                    <label for="html5-text-input" className="col-md-4 col-form-label"> {t("CLIENT_DETAILS.PHONE_1")}</label>
                    <div className="col-md-10">
                      <input
                        type='text'
                        className='form-control'
                        placeholder={t("CLIENT_DETAILS.PHONE_1")}
                        disabled
                        value={client?.phone1}
                      />
                    </div>
                  </div>

                  <div className="mb-3 col-4">
                    <label for="html5-text-input" className="col-md-3 col-form-label"> {t("CLIENT_DETAILS.PHONE_2")}</label>
                    <div className="col-md-10">
                      <input
                        type='text'
                        className='form-control'
                        placeholder={t("CLIENT_DETAILS.PHONE_2")}
                        disabled
                        value={client?.phone2}
                      />
                    </div>
                  </div>
                </div>

                <div className="mb-3 col-8">
                  <label for="html5-text-input" className="col-md-4 col-form-label"> {t("CLIENT_DETAILS.OBSERVATION")}</label>
                  <div className="col-md-10">
                    <textarea
                      type='text'
                      className='form-control'
                      placeholder={t("CLIENT_DETAILS.OBSERVATION")}
                      disabled
                      rows={3}
                      value={client?.notes}
                    ></textarea>
                  </div>
                </div>
              </div>

              <div className={activeTab == "address" ? "tab-pane fade active show" : "tab-pane fade"} id="navs-top-address" role="tabpanel">
                <div className="row">
                  <div className="mb-3 col-4">
                    <label for="html5-text-input" className="col-md-4 col-form-label"> {t("CLIENT_DETAILS.ADDRESS")}</label>
                    <div className="col-md-10">
                      <input
                        type='text'
                        className='form-control'
                        placeholder={t("CLIENT_DETAILS.ADDRESS")}
                        disabled
                        value={client?.billingStreet}
                      />
                    </div>
                  </div>

                  <div className="mb-3 col-3">
                    <label for="html5-text-input" className="col-md-3 col-form-label"> {t("CLIENT_DETAILS.NUMBER")}</label>
                    <div className="col-md-10">
                      <input
                        type='text'
                        className='form-control'
                        placeholder={t("CLIENT_DETAILS.NUMBER")}
                        disabled
                        value={client?.billingNumber}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="mb-3 col-4">
                    <label for="html5-text-input" className="col-md-4 col-form-label"> {t("CLIENT_DETAILS.NEIGHBORHOOD")}</label>
                    <div className="col-md-10">
                      <input
                        type='text'
                        className='form-control'
                        placeholder={t("CLIENT_DETAILS.NEIGHBORHOOD")}
                        disabled
                        value={client?.billingNeighborhood}
                      />
                    </div>
                  </div>

                  <div className="mb-3 col-3">
                    <label for="html5-text-input" className="col-md-3 col-form-label"> {t("CLIENT_DETAILS.COMPLEMENT")}</label>
                    <div className="col-md-10">
                      <input
                        type='text'
                        className='form-control'
                        placeholder={t("CLIENT_DETAILS.COMPLEMENT")}
                        disabled
                        value={client?.billingComplement}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="mb-3 col-3">
                    <label for="html5-text-input" className="col-md-3 col-form-label"> {t("CLIENT_DETAILS.STATE")}</label>
                    <div className="col-md-10">
                      <input
                        type='text'
                        className='form-control'
                        placeholder={t("CLIENT_DETAILS.COMPLEMENT")}
                        disabled
                        value={client?.billingState}
                      />
                    </div>
                  </div>

                  <div className="mb-3 col-4">
                    <label for="html5-text-input" className="col-md-4 col-form-label"> {t("CLIENT_DETAILS.CITY")}</label>
                    <div className="col-md-10">
                      <input
                        type='text'
                        className='form-control'
                        placeholder={t("CLIENT_DETAILS.COMPLEMENT")}
                        disabled
                        value={client?.billingCity}
                      />
                    </div>
                  </div>

                  <div className="mb-3 col-2">
                    <label for="html5-text-input" className="col-md-2 col-form-label"> {t("CLIENT_DETAILS.ZIP_CODE")}</label>
                    <div className="col-md-10">
                      <input
                        type='text'
                        className='form-control'
                        placeholder={t("CLIENT_DETAILS.ZIP_CODE")}
                        disabled
                        value={client?.billingZipCode}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className={activeTab == "address2" ? "tab-pane fade active show" : "tab-pane fade"} id="navs-top-address2" role="tabpanel">
                <div className="row">
                  <div className="mb-3 col-4">
                    <label for="html5-text-input" className="col-md-4 col-form-label"> {t("CLIENT_DETAILS.ADDRESS")}</label>
                    <div className="col-md-10">
                      <input
                        type='text'
                        className='form-control'
                        placeholder={t("CLIENT_DETAILS.ADDRESS")}
                        disabled
                        value={client?.mailingStreet}
                      />
                    </div>
                  </div>

                  <div className="mb-3 col-3">
                    <label for="html5-text-input" className="col-md-3 col-form-label"> {t("CLIENT_DETAILS.NUMBER")}</label>
                    <div className="col-md-10">
                      <input
                        type='text'
                        className='form-control'
                        placeholder={t("CLIENT_DETAILS.NUMBER")}
                        disabled
                        value={client?.mailingNumber}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="mb-3 col-4">
                    <label for="html5-text-input" className="col-md-4 col-form-label"> {t("CLIENT_DETAILS.NEIGHBORHOOD")}</label>
                    <div className="col-md-10">
                      <input
                        type='text'
                        className='form-control'
                        placeholder={t("CLIENT_DETAILS.NEIGHBORHOOD")}
                        disabled
                        value={client?.mailingNeighborhood}
                      />
                    </div>
                  </div>

                  <div className="mb-3 col-3">
                    <label for="html5-text-input" className="col-md-3 col-form-label"> {t("CLIENT_DETAILS.COMPLEMENT")}</label>
                    <div className="col-md-10">
                      <input
                        type='text'
                        className='form-control'
                        placeholder={t("CLIENT_DETAILS.COMPLEMENT")}
                        disabled
                        value={client?.mailingComplement}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="mb-3 col-3">
                    <label for="html5-text-input" className="col-md-3 col-form-label"> {t("CLIENT_DETAILS.STATE")}</label>
                    <div className="col-md-10">
                      <input
                        type='text'
                        className='form-control'
                        placeholder={t("CLIENT_DETAILS.COMPLEMENT")}
                        disabled
                        value={client?.mailingState}
                      />
                    </div>
                  </div>

                  <div className="mb-3 col-4">
                    <label for="html5-text-input" className="col-md-4 col-form-label"> {t("CLIENT_DETAILS.CITY")}</label>
                    <div className="col-md-10">
                      <input
                        type='text'
                        className='form-control'
                        placeholder={t("CLIENT_DETAILS.COMPLEMENT")}
                        disabled
                        value={client?.mailingCity}
                      />
                    </div>
                  </div>

                  <div className="mb-3 col-2">
                    <label for="html5-text-input" className="col-md-2 col-form-label"> {t("CLIENT_DETAILS.ZIP_CODE")}</label>
                    <div className="col-md-10">
                      <input
                        type='text'
                        className='form-control'
                        placeholder={t("CLIENT_DETAILS.ZIP_CODE")}
                        disabled
                        value={client?.mailingZipCode}
                      />
                    </div>
                  </div>
                </div>
              </div>

                <div className={activeTab == "companyRegistration" ? "tab-pane fade active show" : "tab-pane fade"} id="navs-top-address" role="tabpanel">
                <div className="row">
                  <div className="mb-3 col-4">
                    <label for="html5-text-input" className="col-md-4 col-form-label">{t("CLIENT_DETAILS.CNPJ")}</label>
                    <div className="col-md-10">
                      <input
                        type='text'
                        className='form-control'
                        placeholder={t("CLIENT_DETAILS.CNPJ")}
                        disabled
                        value={client?.taxId}
                      />
                    </div>
                  </div>

                  <div className="mb-3 col-3">
                    <label for="html5-text-input" className="col-md-7 col-form-label">{t("CLIENT_DETAILS.STATE_REGISTRATION")}</label>
                    <div className="col-md-10">
                      <input
                        type='text'
                        className='form-control'
                        placeholder={t("CLIENT_DETAILS.STATE_REGISTRATION")}
                        disabled
                        value={client?.stateRegistration}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="mb-3 col-4">
                    <label for="html5-text-input" className="col-md-5 col-form-label">{t("CLIENT_DETAILS.MUNICIPAL_REGISTRATION")}</label>
                    <div className="col-md-10">
                      <input
                        type='text'
                        className='form-control'
                        placeholder={t("CLIENT_DETAILS.MUNICIPAL_REGISTRATION")}
                        disabled
                        value={client?.municipalRegistration}
                      />
                    </div>
                  </div>

                  <div className="mb-3 col-3">
                    <label htmlFor="simples-nacional" className="col-md-15 col-form-label">
                      {t("CLIENT_DETAILS.SIMPLE_TAX_OPTANT")}
                    </label>
                    <div className="d-flex gap-2  form-control">
                      <div className="form-check">
                        <input
                          type="radio"
                          id="sim"
                          name="simplesNacional"
                          value="sim"
                          checked={client?.isSimpleTax === "S"}
                          onChange={() => setOptanteSimples("sim")}
                          className="form-check-input"
                        />
                        <label htmlFor="sim" className="form-check-label">{t("CLIENT_DETAILS.YES")}</label>
                      </div>
                      <div className="form-check">
                        <input
                          type="radio"
                          id="nao"
                          name="simplesNacional"
                          value="nao"
                          checked={client?.isSimpleTax === "N"}
                          onChange={() => setOptanteSimples("nao")}
                          className="form-check-input"
                        />
                        <label htmlFor="nao" className="form-check-label">{t("CLIENT_DETAILS.NO")}</label>
                      </div>
                    </div>
                  </div>

                </div>
                  <div className="mb-3 col-3">
                    <label htmlFor="empresa-publica" className="col-md-15 col-form-label">
                      {t("CLIENT_DETAILS.PUBLIC_COMPANY")}
                    </label>
                    <div className="d-flex gap-2  form-control">
                      <div className="form-check">
                        <input
                          type="radio"
                          id="sim"
                          name="empresaPublica"
                          value="sim"
                          checked={client?.isPublic === "S"}
                          onChange={() => setIsPublic("s")}
                          className="form-check-input"
                        />
                        <label htmlFor="sim" className="form-check-label">{t("CLIENT_DETAILS.YES")}</label>
                      </div>
                      <div className="form-check">
                        <input
                          type="radio"
                          id="nao"
                          name="empresaPublica"
                          value="nao"
                          checked={client?.isPublic === "N"}
                          onChange={() => setIsPublic("n")}
                          className="form-check-input"
                        />
                        <label htmlFor="nao" className="form-check-label">{t("CLIENT_DETAILS.NO")}</label>
                      </div>
                    </div>
                  </div>

        
              </div>

            </div>
          </div>
        </div>
      </div>

    </>);
};

export default ClientDetails;